import React from 'react';
import {Elements} from 'react-stripe-elements';
import InjectedCheckoutForm from './checkOut';

class petposCheckOut extends React.Component {
  render() {
    return (
      <Elements>
        <InjectedCheckoutForm />
      </Elements>
    );
  }
}

export default petposCheckOut;